import { combineReducers } from "redux";
import userReducer from "./userReducer";
import tokenReducer from "./tokenReducer";

import prospectReducer from "./prospectReducer";

import utilReducer from "./utilReducer";

export default combineReducers({
  user: userReducer,
  token: tokenReducer,
  prospects: prospectReducer,
  utils: utilReducer,
});
